/* @flow */

import React from 'react';
import { Segment, Form } from 'semantic-ui-react';
import LayoutsSelector from './LayoutsSelector';
import { NETWORK_MODES, SECURITY_CONTEXTS } from 'catalog/constants';

type Props = {
  page: CatalogPage,
  settings: CatalogSettings,
  content?: CatalogPageContent,
  hasUpdate: boolean,
  isUpdating: boolean,
  onChange: (page: CatalogPage) => void,
  onChangeLayout: (layout: CatalogLayout) => void,
};

const PageForm = ({
  page,
  settings,
  content,
  hasUpdate,
  isUpdating,
  onChange,
  onChangeLayout,
}: Props) => {
  const nameChanged = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      onChange({
        ...page,
        name: event.target.value,
      });
    }
  };

  const networkModeChanged = (_, { value }) =>
    onChange({
      ...page,
      networkMode: value,
    });

  const securityContextChanged = (_, { value }) =>
    onChange({
      ...page,
      securityContext: value,
    });

  return (
    <Segment>
      <Form>
        <Form.Field>
          <label>Nom</label>
          <input type="text" value={page.name} onChange={nameChanged} />
        </Form.Field>
        {settings.canOverrideNetworkMode &&
          <Form.Select
            label="Connectivité"
            value={page.networkMode || settings.defaultNetworkMode}
            options={NETWORK_MODES}
            onChange={networkModeChanged}
          />}
        {settings.canOverrideSecurityContext &&
          <Form.Select
            label={`Contexte d'authentification`}
            value={
              page.securityContext || settings.defaultSecurityContext || 'none'
            }
            options={SECURITY_CONTEXTS}
            onChange={securityContextChanged}
          />}
        <LayoutsSelector
          content={content}
          hasUpdate={hasUpdate}
          isUpdating={isUpdating}
          onChange={onChangeLayout}
        />
      </Form>
    </Segment>
  );
};

export default PageForm;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Edit/components/PageForm.js